export const GOVERNANCE_ROUTES = {
  GOVERNANCE_RULES: "/rules",
  GOVERNANCE_AI_AUDIT: "/ai-audit",
  GOVERNANCE_AI_PRIVACY_RULES: "/rules/llm-privacy",
  GOVERNANCE_LLM_PRIVACY: "/rules/llm-privacy",
  GOVERNANCE_TRIAGE_TEMPLATES: "/triage-templates",
  GOVERNANCE_THREAD_DIGEST_TEMPLATES: "/thread-digest-templates",
  GOVERNANCE_DRAFT_TEMPLATES: "/prompt-templates",
  GOVERNANCE_REQUEST_INFO_TEMPLATES: "/request-info-templates",
  GOVERNANCE_TEMPLATE_ROUTING_RULES: "/rules/template-routing-rules",
  GOVERNANCE_ADMINISTRATION: "/admin",
  GOVERNANCE_OPERATIONAL_SETTINGS: "/admin/operational",
  GOVERNANCE_INTEGRATIONS: "/admin/integrations",
  GOVERNANCE_SYNC_DIAGNOSTICS: "/admin/sync-diagnostics",
  GOVERNANCE_CONTEXT_CATALOG: "/governance/knowledge/catalog",
  GOVERNANCE_CONTEXT_ENABLEMENT: "/governance/knowledge/enablement",
  GOVERNANCE_CONTEXT_DRIFT: "/governance/knowledge/drift",
  GOVERNANCE_CONTEXT_OPS: "/governance/knowledge/ops",
} as const;

export type GovernanceRouteKey = keyof typeof GOVERNANCE_ROUTES;
